<template>
  <div class="animated fadeIn common-color dashboard-page">
    <b-row>
      <b-col sm="12" lg="8" class="mb-3">
        <b-card>
          <div slot="header">
            <strong>Admin-assisted bookings</strong>
            <span class="text-muted ml-2">Book on behalf of patient</span>
          </div>
          <b-row>
            <b-col sm="6" md="4" v-for="card in adminBookingCards" :key="card.key" class="mb-3">
              <div class="dash-stat" :class="card.tone">
                <div class="dash-stat-label">{{ card.label }}</div>
                <div class="dash-stat-value">{{ card.value }}</div>
                <div class="dash-stat-help">{{ card.help }}</div>
              </div>
            </b-col>
          </b-row>
          <p class="dash-footnote mb-0">
            Payment links land on the dedicated patient checkout (<code>register/admin-booking</code>).
            Instant bookings (100% coupon) appear under admin instant bookings.
            <router-link to="/patients" @click="goInvitesTab">View consultation invites</router-link>
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'dashboard',
  data: function () {
    return {
      summary: {
        inviteLinksStored: 0,
        invitesPending: 0,
        invitesPaid: 0,
        slotHoldsActive: 0,
        slotHoldsUsed: 0,
        adminInstantBookings: 0
      }
    }
  },
  computed: {
    adminBookingCards () {
      const s = this.summary
      return [
        {
          key: 'links',
          label: 'Payment links sent',
          value: s.inviteLinksStored,
          help: 'Patients with a stored checkout link',
          tone: ''
        },
        {
          key: 'pending',
          label: 'Awaiting payment',
          value: s.invitesPending,
          help: 'Invite sent, not booked yet',
          tone: 'warn'
        },
        {
          key: 'paid',
          label: 'Booked via link',
          value: s.invitesPaid,
          help: 'Patient completed checkout',
          tone: 'ok'
        },
        {
          key: 'holds',
          label: 'Slots on hold',
          value: s.slotHoldsActive,
          help: 'Reserved until pay or expiry',
          tone: ''
        },
        {
          key: 'used',
          label: 'Holds used',
          value: s.slotHoldsUsed,
          help: 'Link checkout completed',
          tone: 'ok'
        },
        {
          key: 'instant',
          label: 'Admin instant bookings',
          value: s.adminInstantBookings,
          help: 'Booked in admin (e.g. 100% coupon)',
          tone: ''
        }
      ]
    }
  },
  created () {
    this.loadSummary()
  },
  methods: {
    loadSummary () {
      this.$patientService.getAdminBookingSummary()
        .then(data => {
          if (data) {
            this.summary = Object.assign({}, this.summary, data)
          }
        })
        .catch(() => {})
    },
    goInvitesTab () {
      sessionStorage.setItem('patientsActiveTab', 'invites')
    }
  }
}
</script>

<style lang="scss">
html body {
  background-color:#e4e5e6;
}
.dashboard-page .dash-stat {
  border: 1px solid #e4e7ea;
  border-radius: 8px;
  padding: 14px;
  background: #fff;
  min-height: 120px;
}
.dashboard-page .dash-stat.warn {
  border-color: #f0d9a8;
  background: #fffbf3;
}
.dashboard-page .dash-stat.ok {
  border-color: #b8e6c8;
  background: #f6fffa;
}
.dashboard-page .dash-stat-label {
  font-size: 0.78rem;
  text-transform: uppercase;
  color: #636b75;
  letter-spacing: 0.02em;
}
.dashboard-page .dash-stat-value {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 6px 0;
}
.dashboard-page .dash-stat-help {
  font-size: 0.8rem;
  color: #7a828c;
}
.dashboard-page .dash-footnote {
  font-size: 0.85rem;
  color: #5c6570;
  border-top: 1px solid #e4e7ea;
  padding-top: 12px;
  margin-top: 4px;
}
</style>
